import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import auth from './modules/auth'
import users from './modules/users'
import permissions from './modules/permissions'

import tickets from './modules/tickets'
import announcements from './modules/announcements'

import documents from './modules/documents'

import units from './modules/units'

import sampleRequest from './modules/sampleRequest'
import sampleRequests from './modules/sampleRequests'
import samples from './modules/samples'

import proposalMaker from './modules/proposalMaker'
import projects from './modules/projects'
import materials from './modules/materials'

import cutSheets from './modules/cutSheets'
import skids from './modules/skids'
import assembly from './modules/assembly'

import workstations from './modules/workstations'
import masterProductions from './modules/masterProductions'
import masterProductionSteps from './modules/masterProductionSteps'
import workstationQueues from './modules/workstationQueues'
import workSteps from './modules/workSteps'

import warehouses from './modules/warehouses'
import warehouseLocation from './modules/warehouseLocation'
import warehouseLocations from './modules/warehouseLocations'
import warehouseItems from './modules/warehouseItems'
import delivery from './modules/delivery'
import deliveries from './modules/deliveries'
import storage from './modules/storage'
import storages from './modules/storages'
import storageTypes from './modules/storageTypes'

import products from './modules/products'
import suppliers from './modules/suppliers'
import bom from './modules/bom'
import boms from './modules/boms'
import order from './modules/order'
import orders from './modules/orders'
import productionSheet from './modules/productionSheet'
import productionSheets from './modules/productionSheets'
import productionSheetItems from './modules/productionSheetItems'
import inventoryCentral from './modules/inventoryCentral'
import inventoryProject from './modules/inventoryProject'

import estimationSummary from './modules/estimationSummary'
import rfq from './modules/rfq'
import rfqs from './modules/rfqs'
import rfqsProjects from './modules/rfqsProjects'
import rfqDocumentTypes from './modules/rfqDocumentTypes'
import drawingHighlight from './modules/drawingHighlight'
import drawingHighlights from './modules/drawingHighlights'
import estimation from './modules/estimation'
import estimations from './modules/estimations'
import cladifyEstimation from './modules/cladifyEstimation'
import cladifyEstimations from './modules/cladifyEstimations'
import installMethods from './modules/installMethods'
import elevations from './modules/elevations'
import fabrications from './modules/fabrications'
import processings from './modules/processings'
import services from './modules/services'
import installations from './modules/installations'

import installationSummary from './modules/installationSummary'
import installationItems from './modules/installationItems'
import skidInstallations from './modules/skidInstallations'
import skid from './modules/skid'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    //app
    auth,
    app,
    // permissions - policies
    users,
    permissions,
    //ticketing
    tickets,
    announcements,
    //documents
    documents,
    //units
    units,
    //sample requests
    sampleRequest,
    sampleRequests,
    samples,
    //estimations
    estimationSummary,
    rfq,
    rfqs,
    rfqsProjects,
    rfqDocumentTypes,
    drawingHighlight,
    drawingHighlights,
    estimation,
    estimations,
    cladifyEstimation,
    cladifyEstimations,
    materials,
    installMethods,
    elevations,
    fabrications,
    services,
    installations,
    processings,
    //proposals
    proposalMaker,
    projects,
    //manufacturing
    cutSheets,
    skids,
    assembly,
    //inventory
    products,
    suppliers,
    bom,
    boms,
    order,
    orders,
    productionSheet,
    productionSheets,
    productionSheetItems,
    inventoryCentral,
    inventoryProject,
    //scheduling
    workstations,
    masterProductions,
    masterProductionSteps,
    workstationQueues,
    workSteps,
    //warehousing
    warehouses,
    warehouseLocation,
    warehouseLocations,
    warehouseItems,
    delivery,
    deliveries,
    storage,
    storages,
    storageTypes,
    installationSummary,
    installationItems,
    skidInstallations,
    skid
  }
})
